import styled from '@emotion/styled';
import React from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const StyledAlert = styled(Alert)`
    margin-top: 0.625rem;

    li {
        white-space: pre-line;
    }
`;

const Error = ({ errorMessage }) => {
    if (!errorMessage) {
        return null;
    }

    return (
        <Row>
            <Col md={8}>
                <StyledAlert variant="danger">
                    <ul>
                        <li>{errorMessage}</li>
                    </ul>
                </StyledAlert>
            </Col>
        </Row>
    );
};

Error.propTypes = {
    errorMessage: PropTypes.string,
};

Error.defaultProps = {
    errorMessage: null,
};

export default Error;
